export interface ChatMessage {
  from: 'user' | 'ai';
  text: any;
  textComplete?: boolean;
  error?: any;
  errorDetails?: any; // Detalles técnicos del error para el modal
  queryProcessResult?: any;
  rawResponse?: any;
  isStreaming?: boolean; // Flag para mensajes en streaming
  cycleHistory?: Array<{
    cycle: number;
    title: string;
    content: string;
    toolCalls?: Array<{ name: string; input: string; output: string; status?: string }>;
  }>; // Historial de razonamiento
  actionButton?: {
    label: string;
    action: string;
    payload?: any;
    icon?: string;
  };
}

export interface ChatSessionHistoryItem {
  id: string;
  conversationId?: string; // ID real de la conversación para mantener contexto
  name: string;
  description: string;
  date: Date;
  messageCount: number;
  agentType: string;
  lastMessage: string;
  suggestion?: any; // InsightSuggestion linked to this session
}

export interface ChatContentComponent {
  messages: ChatMessage[];
  loading: boolean;
  userInput: string;

  sendMessage(message: string): void;
  resetConversation(): void;
  scrollToBottom(): void;
}

export enum ChatType {
  DATABRICKS = 'databricks',
  STREAMING = 'streaming', // Nuevo tipo para streaming chat
  // Agregar futuros tipos aquí
  // OPENAI = 'openai',
  // CUSTOM = 'custom'
}
